import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView, ILanguageObject } from '@core/interfaces';
import { Store as StoreModel } from '@core/models';
import { StoreDeliveryCodeEnum } from '../../../enums';
import { IStoresListCallback } from '../../../interfaces';
import { StoreCardComponent } from '../../store-card/store-card.component';
import { DeliveryStrategyPresenter } from './delivery-strategy.presenter';
import { IDeliveryStrategyComponent, IDeliveryStrategyPresenter } from './interfaces';

@Component({
	selector: 'app-delivery-strategy',
	templateUrl: './delivery-strategy.component.html',
	styleUrls: ['./delivery-strategy.component.scss'],
	providers: [DeliveryStrategyPresenter],
	standalone: true,
	imports: [CommonModule, StoreCardComponent],
})
export class DeliveryStrategyComponent
	extends IAbstractView<IDeliveryStrategyPresenter>
	implements IDeliveryStrategyComponent
{
	@Input() stores: StoreModel[] = [];
	@Input() translations: ILanguageObject = {};
	@Input({ required: true }) callback!: IStoresListCallback;

	readonly StoreDeliveryCodeEnum = StoreDeliveryCodeEnum;

	constructor(presenter: DeliveryStrategyPresenter) {
		super(presenter);
	}

	onSelectStore(store: StoreModel, code: StoreDeliveryCodeEnum): void {
		this.presenter.onSelectStore(store, code);
	}
}
